export enum MenuItemTestIds {
  ROOT = 'menu-item-root',
  TITLE = 'menu-item-title',
  TITLE_WRAP = 'menu-item-title-wrap',
  AVATAR = 'menu-item-avatar',
  FALLBACK_AVATAR = 'menu-item-fallback-avatar',
  TEXT = 'menu-item-text',
  USER_EMAIL = 'menu-item-user-email',
  USER_PHONE = 'menu-item-user-phone',
  RECOMMENDED_PRODUCTS = 'menu-item-user-recommended-products',
  WATCH_LATEST_VIDEO = 'menu-item-user-watch-latest-video-',
  EXPANDER = 'menu-item-expander-button',
  USER_NAME = 'menu-item-user-name',
  BENEFITS_LINK = 'menu-item-benefits-link',
}
